import React, { useEffect, useState } from 'react';
import useAxios from '../utils/useAxios';
import Swal from 'sweetalert2';
import { FaCheckCircle, FaTimesCircle, FaEye, FaInfoCircle, FaSearch } from 'react-icons/fa';
import { useSidebar } from '../context/SidebarContext';
import OrganisationSelector from '../components/OrganisationSelector';
import styles from '../styles/AbsencesRHPage';
import { useAuth } from '../context/AuthContext';



const AbsencesRHPage = () => {
  const api = useAxios();
  const [absences, setAbsences] = useState([]);
  const [filters, setFilters] = useState({ date_debut: '', date_fin: '', statut: '', nom_employe: '' });
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({ totalPages: 1 });
  const [loading, setLoading] = useState(false);

  const [showRefusModal, setShowRefusModal] = useState(false);
  const [currentRefus, setCurrentRefus] = useState(null);
  const [motifRefus, setMotifRefus] = useState('');
  const { sidebarVisible } = useSidebar();
  
  // États pour la gestion des organisations
  const [selectedOrganisation, setSelectedOrganisation] = useState('');
  const [currentOrganisation, setCurrentOrganisation] = useState(null);
 
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedAbsence, setSelectedAbsence] = useState(null);
  const { user } = useAuth();

  const handleOrganisationChange = (orgId, org) => {
    setSelectedOrganisation(orgId);
    setCurrentOrganisation(org);
    
    setPage(1);
  };

  const fetchAbsences = async () => {
    if (!selectedOrganisation) {
      setAbsences([]);
      return;
    }
    
    setLoading(true);
    try {
      const params = {
        page,
        organisation: selectedOrganisation,
      };
      
    
      if (filters.date_debut) params.date_debut = filters.date_debut;
      if (filters.date_fin) params.date_fin = filters.date_fin;
      if (filters.statut) params.statut = filters.statut;
      if (filters.nom_employe) params.nom_employe = filters.nom_employe;
      
      const res = await api.get('/pointage/absences/', { params });
      
    
      if (res.data && Array.isArray(res.data.results)) {
        setAbsences(res.data.results);
      } else if (Array.isArray(res.data)) {
       
        setAbsences(res.data);
      } else {
        setAbsences([]);
      }
      
   
      if (res.data && res.data.count !== undefined) {
        setPagination({ totalPages: Math.ceil(res.data.count / 10) });
      } else if (res.data && res.data.totalPages !== undefined) {
        setPagination({ totalPages: res.data.totalPages });
      } else {
        setPagination({ totalPages: 1 });
      }
    } catch (error) {
      console.error('Erreur lors du chargement des absences:', error);
      Swal.fire('Erreur', "Impossible de charger les absences", 'error');
      setAbsences([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchAbsences();
  }, [page, filters, selectedOrganisation]);

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
    setPage(1);
  };

  const handleApprouver = async (id) => {
    try {
      await api.patch(`/pointage/absences/${id}/`, { statut: 'approuvée' });
      // Recharger les données après l'action
      await fetchAbsences();
      Swal.fire('Succès', 'Absence approuvée.', 'success');
    } catch (error) {
      Swal.fire('Erreur', 'Impossible de valider l\'absence', 'error');
    }
  };

  const handleRefuserClick = (absence) => {
    setCurrentRefus(absence);
    setMotifRefus('');
    setShowRefusModal(true);
  };

  const handleRefusSubmit = async (e) => {
    e.preventDefault();
    if (!motifRefus.trim()) {
      Swal.fire('Erreur', 'Veuillez indiquer un motif de refus.', 'error');
      return;
    }
    try {
      await api.patch(`/pointage/absences/${currentRefus.id}/`, {
        statut: 'refusée',
        motif_refus: motifRefus.trim(),
      });
      setShowRefusModal(false);
      // Recharger les données après l'action
      await fetchAbsences();
      Swal.fire('Succès', 'Absence refusée avec motif.', 'success');
    } catch (error) {
      Swal.fire('Erreur', 'Impossible de refuser l\'absence', 'error');
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= pagination.totalPages) {
      setPage(newPage);
    }
  };

  const renderBadge = (statut) => {
    switch (statut) {
      case 'en_attente':
        return <span style={styles.badgeEnAttente}>En attente</span>;
      case 'approuvée':
        return <span style={styles.badgeApprouvee}>Approuvée</span>;
      case 'refusée':
        return <span style={styles.badgeRefusee}>Refusée</span>;
      default:
        return <span style={styles.badgeInconnu}>Inconnu</span>;
    }
  };

  const openDetailModal = (absence) => {
    setSelectedAbsence(absence);
    setShowDetailModal(true);
  };

  
  const absencesList = Array.isArray(absences) ? absences : [];

  return (
    <div style={{...styles.container, marginLeft: sidebarVisible ? 250 : 0}}>
      {/* Modal Détail */}
      {showDetailModal && selectedAbsence && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1060 }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" style={{ color: '#1B019B' }}>
                  Détail de l'absence de {selectedAbsence.employe?.first_name} {selectedAbsence.employe?.last_name}
                </h5>
                <button className="btn-close" onClick={() => setShowDetailModal(false)}></button>
              </div>
              <div className="modal-body" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                <div style={styles.detailGrid}>
                  <div style={styles.detailItem}>
                    <strong>Employé:</strong> {selectedAbsence.employe?.first_name} {selectedAbsence.employe?.last_name}
                  </div>
                  <div style={styles.detailItem}>
                    <strong>Date début:</strong> {selectedAbsence.date_debut}
                  </div>
                  <div style={styles.detailItem}>
                    <strong>Date fin:</strong> {selectedAbsence.date_fin}
                  </div>
                  <div style={styles.detailItem}>
                    <strong>Statut:</strong> {renderBadge(selectedAbsence.statut)}
                  </div>
                  <div style={styles.detailItem}>
                    <strong>Motif:</strong> 
                    <div style={styles.justificationText}>
                      {selectedAbsence.motif}
                    </div>
                  </div>
                  {selectedAbsence.justificatif && (
                    <div style={styles.detailItem}>
                      <strong>Fichier joint:</strong>
                      <a 
                        href={selectedAbsence.justificatif} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={styles.fileLink}
                      >
                        <FaEye /> Voir le fichier
                      </a>
                    </div>
                  )}
                  {selectedAbsence.motif_refus && (
                    <div style={styles.detailItem}>
                      <strong>Motif de refus:</strong> 
                      <div style={styles.justificationText}>
                        {selectedAbsence.motif_refus}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button 
                  className="btn btn-secondary" 
                  onClick={() => setShowDetailModal(false)}
                >
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="text-center mb-3">
        <h3 style={styles.header}>Gestion des Absences</h3>
        <hr style={styles.hr} />
      </div>

      {/* Header avec sélecteur d'organisation */}
      <div style={styles.organisationHeader}>
        <OrganisationSelector 
          onOrganisationChange={handleOrganisationChange}
          selectedOrganisation={selectedOrganisation}
        />

        {currentOrganisation && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span style={{ color: '#666', fontSize: '14px' }}>
              Absences à valider pour cette organisation
            </span>
          </div>
        )}
      </div>

      {currentOrganisation ? (
        <>
          <div style={styles.filterContainer}>
            <div style={styles.filterGroup}>
              <input
                type="date"
                className="form-control"
                name="date_debut"
                value={filters.date_debut}
                onChange={handleChange}
                style={styles.dateInput}
                placeholder="Date début"
              />
            </div>
            <div style={styles.filterGroup}>
              <input
                type="date"
                className="form-control"
                name="date_fin"
                value={filters.date_fin}
                onChange={handleChange}
                style={styles.dateInput}
                placeholder="Date fin"
              />
            </div>
            <div style={styles.filterGroup}>
              <select
                name="statut"
                className="form-select"
                value={filters.statut}
                onChange={handleChange}
                style={styles.select}
              >
                <option value="">Tous les statuts</option>
                <option value="en_attente">En attente</option>
                <option value="approuvée">Approuvée</option>
                <option value="refusée">Refusée</option>
              </select>
            </div>
            <div style={styles.filterGroup}>
              <div style={{ position: 'relative' }}>
                <input
                  type="text"
                  className="form-control"
                  name="nom_employe"
                  value={filters.nom_employe}
                  onChange={handleChange}
                  style={styles.searchInput}
                  placeholder="Rechercher par nom"
                />
                <FaSearch style={styles.searchIcon} />
              </div>
            </div>
          </div>

          <div className="card shadow-sm mb-4" style={{ borderRadius: '15px', border: 'none' }}>
            <div className="card-body table-responsive p-0">
              <table className="table table-hover text-center align-middle m-0">
                <thead style={styles.tableHeader}>
                  <tr>
                    <th>Employé</th>
                    <th>Date début</th>
                    <th>Date fin</th>
                    <th>Justification</th>
                    <th>Statut</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr><td colSpan="6">Chargement...</td></tr>
                  ) : absencesList.length === 0 ? (
                    <tr><td colSpan="6" className="text-muted">Aucune absence trouvée.</td></tr>
                  ) : (
                    absencesList.map((a) => (
                      <tr key={a.id}>
                        <td>{a.employe?.first_name} {a.employe?.last_name}</td>
                        <td>{a.date_debut}</td>
                        <td>{a.date_fin}</td>
                        <td>
                          <button
                            onClick={() => openDetailModal(a)}
                            style={styles.detailButton}
                            title="Voir les détails de l'absence"
                          >
                            <FaInfoCircle /> Détails
                          </button>
                        </td>
                        <td>{renderBadge(a.statut)}</td>
                        <td>
                          <div style={styles.actionButtons}>
                            {a.statut === 'en_attente' ? (
                              <>
                              
	
                              {(user?.is_super_admin || user?.permissions?.includes("APPROVE_LEAVE_REQUEST")) && (
                                <button
                                  style={styles.approveButton}
                                  onClick={() => handleApprouver(a.id)}
                                  title="Approuver"
                                  disabled={loading}
                                >
                                  <FaCheckCircle />
                                </button>
                              )}
                              {(user?.is_super_admin || user?.permissions?.includes("REJECT_LEAVE_REQUEST")) && (
                                <button
                                  style={styles.refuseButton}
                                  onClick={() => handleRefuserClick(a)}
                                  title="Refuser"
                                  disabled={loading}
                                >
                                  <FaTimesCircle />
                                </button>
                              )}
                              </>
                            ) : (
                              <span className="text-muted">Aucune action</span>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {pagination.totalPages > 1 && (
              <div className="card-footer d-flex justify-content-center mt-3 bg-transparent border-top-0">
                <nav>
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(1)}
                        disabled={page === 1 || loading}
                        style={page === 1 || loading ? styles.paginationDisabled : styles.paginationButton}
                      >
                        Première
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(page - 1)}
                        disabled={page === 1 || loading}
                        style={page === 1 || loading ? styles.paginationDisabled : styles.paginationButton}
                      >
                        &laquo;
                      </button>
                    </li>

                    {Array.from({ length: pagination.totalPages }, (_, i) => i + 1).map((p) => (
                      <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(p)}
                          disabled={loading}
                          style={page === p ? { ...styles.paginationButton, ...styles.paginationActive } : styles.paginationButton}
                        >
                          {p}
                        </button>
                      </li>
                    ))}

                    <li className="page-item">
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(page + 1)}
                        disabled={page === pagination.totalPages || loading}
                        style={page === pagination.totalPages || loading ? styles.paginationDisabled : styles.paginationButton}
                      >
                        &raquo;
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(pagination.totalPages)}
                        disabled={page === pagination.totalPages || loading}
                        style={page === pagination.totalPages || loading ? styles.paginationDisabled : styles.paginationButton}
                      >
                        Dernière
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            )}
          </div>

          {/* Modal Motif Refus */}
          {showRefusModal && currentRefus && (
            <div style={{...styles.modalBackdrop, zIndex: 1070}} onClick={() => setShowRefusModal(false)}>
              <div
                style={styles.modalContent}
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
                aria-labelledby="modalTitle"
              >
                <h5 id="modalTitle" className="mb-3" style={{color: 'red'}}>
                  Refuser l'absence de {currentRefus.employe?.first_name} {currentRefus.employe?.last_name}
                </h5>
                <form onSubmit={handleRefusSubmit}>
                  <div className="mb-3">
                    <textarea
                      className="form-control"
                      rows="4"
                      value={motifRefus}
                      onChange={(e) => setMotifRefus(e.target.value)}
                      placeholder="Saisir le motif de refus ici..."
                      required
                    />
                  </div>
                  <div className="d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-secondary me-2"
                      onClick={() => setShowRefusModal(false)}
                      disabled={loading}
                    >
                      Annuler
                    </button>
                    <button type="submit" className="btn btn-danger" disabled={loading}>
                      {loading ? 'Traitement...' : 'Refuser'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </>
      ) : (
        <div className="text-center py-5">
          <p className="text-muted">Sélectionnez une organisation pour commencer</p>
        </div>
      )}
    </div>
  );
};

export default AbsencesRHPage;